import {Routes} from 'constants/routes';

/* eslint-disable no-nested-ternary */
import {useState} from 'react';

import Icon from 'components/Icon/Icon';
import {Link} from 'react-router-dom';
import {deleteAccount, login} from 'services/auth-service';
import {LoginDTO} from 'typescript/dto/authDto';
import UserBase from 'typescript/models/UserBase';

import './DeleteAccount.scss';
import ConfirmDeleteAccountForm from './ConfirmDeleteAccountForm';
import DeleteLoginForm from './DeleteLoginForm';

const DeleteAccount = () => {
  const [user, setUser] = useState<UserBase | null>(null);
  const [token, setToken] = useState<string | null>(null);
  const [deleted, setDeleted] = useState<boolean>(false);

  const handleSubmit = async (values: LoginDTO) => {
    const response = await login(values, true);

    setUser(response.data);
    setToken(response.headers.authorization);
  };

  const handleConfirmDelete = async () => {
    if (token) {
      const response = await deleteAccount(token, true);
      if (response.status >= 200 && response.status <= 299) {
        setDeleted(true);
      }
    }
  };

  return (
    <div className="delete-account">
      <div className="delete-account__cloud-up" />
      <div className="delete-account__header">
        <Link to={Routes.HOME}>
          <Icon icon="login_logo" />
        </Link>
      </div>
      {token ? (
        deleted ? (
          <div className="delete-account__container">
            <div className="delete-account__welcome">
              <h1 className="delete-account__welcome-title">Account Deleted</h1>
              <h2 className="delete-account__welcome-subtitle">
                We are sorry to see you leave.
                <br /> You are always welcome to join Tapspots again!
              </h2>

              <a className="text-white text-decoration-none" href="https://tapspots.com/">
                Go back to Website
              </a>
            </div>

            <div className="delete-account__footer" />
          </div>
        ) : (
          <ConfirmDeleteAccountForm handleConfirmDelete={handleConfirmDelete} user={user} />
        )
      ) : (
        <DeleteLoginForm handleSubmit={handleSubmit} />
      )}
    </div>
  );
};

export default DeleteAccount;
